<template>
	<v-expansion-panels :class="{
		'px-1 elevantion-1': true,
		'rounded-b-lg rounded-t-0': uploadFilePermission
	}" style="margin-top: 1px;" v-model="filterExpanded">
		<v-expansion-panel>
			<v-container
				fluid
				class="py-0 pl-8">
				<v-row
					class="foreground--text align-start">
					<v-col
						cols="12"
						xl="1"
						lg="2"
						md="3"
						sm="3"
						xs="12"
						class="pl-1 d-flex align-start pt-3">
						<span
							class="text-h6 font-weight-bold foreground--text filter-header-label">
							Filtro
						</span>
					</v-col>
					<v-col cols="12" xl="11" lg="10" md="9" sm="9" xs="12">
						<v-row no-gutters>
							<v-col cols="12" xl="11" lg="11" md="10" sm="12" xs="12">
								<v-row class="py-3">
									<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
										<v-select prepend-inner-icon="fas fa-calendar-alt" v-model="selectedDate"
											:items="dateList" v-bind="fieldFilterProps" />
									</v-col>
									<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12"
										v-if="selectedDate === 'custom'">
										<v-menu max-width="350px" v-model="menuDateCustom" ref="menuDateCustom"
											transition="scale-transition" offset-y :close-on-content-click="false"
											:return-value.sync="dates">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field v-model="dateRangeText" readonly outlined dense
													hide-details v-bind="attrs" v-on="on" />
											</template>
											<v-date-picker width="auto" range v-model="dates" no-title color="primary">
												<v-row class="mx-2">
													<v-col cols="12" class="d-flex align-end">
														<v-btn text color="primary" @click="menuDateCustom = false">
															Cancelar
														</v-btn>
														<v-btn text color="primary" @click="handlerDate(dates)">
															OK
														</v-btn>
													</v-col>
												</v-row>
											</v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
										<v-autocomplete outlined dense v-model="filterDataLoad.subject"
											label="Tipo de arquivo" v-bind="autoCompleteProps"
											:items="getDataLoadFileTypes" />
									</v-col>
									<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
										<v-autocomplete outlined dense v-model="filterDataLoad.carrierId"
											label="Operadora" v-bind="autoCompleteCarrierProps" :items="carriers" />
									</v-col>
									<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
										<v-menu ref="menu" v-model="menu" :close-on-content-click="false"
											transition="scale-transition" offset-y max-width="290px" min-width="auto">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field v-model="filterDataLoad.competence"
													placeholder="Selecione" label="Competência" readonly outlined dense
													hide-details v-bind="textFieldProps" v-on="on"
													@input="handlerFilter" />
											</template>
											<v-date-picker @click="setCompentence" v-model="date" type="month"
												locale="pt-br" color="primary" no-title scrollable>
												<v-spacer />
												<v-btn text @click="cleanCompetence">
													LIMPAR
												</v-btn>
												<v-btn text @click="setCompentence">
													OK
												</v-btn>
											</v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
										<v-text-field
											v-model="filterDataLoad.fileName"
											label="Nome do arquivo"
											v-bind="textFieldProps"
										/>
									</v-col>
								</v-row>
							</v-col>
							<v-col :class="{
								'd-flex flex-row align-start pt-3': true,
								'justify-space-between': !$vuetify.breakpoint.lgAndDown,
								'justify-end': $vuetify.breakpoint.lgAndDown,
							}" cols="12" xl="1" lg="1" md="2" sm="12" xs="12">
								<v-btn icon class="primary mx-4" @click="handlerFilter">
									<v-img height="30" contain src="icons/sync.svg" :class="{
										syncSearchTransition: loadSearch
									}" />
								</v-btn>
								<v-icon
									class="onClickEffect mr-3 filter-expand-icon"
									:style="syncIconTransition"
									@click="expand">
									fas fa-chevron-up
								</v-icon>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
			<v-expansion-panel-content>
				<v-container fluid class="pr-0">
					<v-row class="primary--text">
						<v-col cols="12" xl="1" lg="2" md="3" sm="3" xs="12" class="d-flex justify-start pl-1">
							<div @click.stop="handlerClearFilters" style="cursor: pointer;">
								<v-icon class="pr-2" color="primary" size="15">
									fas fa-redo
								</v-icon>
								<span
									class="text-subtitle-2 font-weight-regular primary--text">
									Limpar filtros
								</span>
							</div>
						</v-col>
						<v-col cols="12" xl="11" lg="10" md="9" sm="9" xs="12" class="pr-0">
							<v-row no-gutters>
								<v-col cols="12" xl="11" lg="11" md="10" sm="12" xs="12">
									<v-row>
										<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
											<v-autocomplete v-model="filterDataLoad.financialGroupId"
												label="Grupo financeiro" v-bind="autoCompleteProps"
												:items="financialGroups" />
										</v-col>
										<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
											<v-autocomplete v-model="filterDataLoad.contractId" label="Contrato"
												v-bind="autoCompleteProps" :items="contracts"
												:loading="loadingContracts" />
										</v-col>
										<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
											<v-autocomplete v-model="filterDataLoad.subContractId" label="Subcontrato"
												v-bind="autoCompleteProps" :items="subContracts"
												:loading="loadingSubContracts" />
										</v-col>
										<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
											<v-text-field v-model="filterDataLoad.id" label="Nº Protocolo"
												v-bind="textFieldProps" />
										</v-col>
										<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
											<v-autocomplete v-model="filterDataLoad.status" label="Etapa"
												v-bind="autoCompleteProps" :items="getStatusList" />
										</v-col>
										<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
											<v-autocomplete v-model="filterDataLoad.extProcessStatus" label="Status"
												v-bind="autoCompleteProps" :items="getExtProcessStatusList" />
										</v-col>
										<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
											<v-text-field v-model="filterDataLoad.createdBy" label="Criado por"
												v-bind="textFieldProps" />
										</v-col>
										<v-col
											cols="12"
											xl="3"
											lg="3"
											md="6"
											sm="6"
											xs="12">
											<v-text-field
												outlined
												dense
												v-model="filterDataLoad.helpdeskId"
												label="Atendimento"
												v-bind="textFieldProps"
												v-mask="'#######'"
											/>
										</v-col>
										<v-col
											cols="12"
											xl="3"
											lg="3"
											md="6"
											sm="6"
											xs="12">
											<v-switch
												v-model="filterDataLoad.filesToReprocess"
												label="Arquivos para reprocessamento"
												v-bind="textFieldProps"
												inset
												class="mt-2"
												color="success"
											/>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" xl="1" lg="1" md="2" sm="12" xs="12" />
							</v-row>
							<v-row>
								<v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
									<v-switch v-model="filterDataLoad.sourceType"
										label="Somente API" v-bind="textFieldProps" inset class="mt-2"
										color="success" />
								</v-col>

							</v-row>
						</v-col>
						<v-col
							cols="1"
						/>
					</v-row>
				</v-container>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
import DataLoadMixin from '@/shared/mixins/dataLoad/dataLoadMixin';
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import FavoriteSearchComponent from '@/components/FavoriteSearchFilters/FavoriteSearchComponent.vue';
import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import DataLoadService from '@/services-http/sdi/DataLoadService';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import DataLoadStore from '@/store/modules/data-load/data-load-module';
import moment from 'moment';
import lodash from 'lodash';

export default {
	name: "DataLoadFilter",

	components: {
		FavoriteSearchComponent
	},

	data: () => ({
		date: null,
		filterExpanded: null,
		selectedDate: null,
		menuDateCustom: false,
		dates: [],
		datesSearch: null,
		dateType: ['createdAt'],
		dateList: [
			{
				text: 'Últimos 7 dias',
				value: 'lastSevenDays',
				disabled: false,
			},
			{
				text: 'Últimos 30 dias',
				value: 'lastThirtyDays',
				disabled: false,
			},
			{
				text: 'Últimos 3 meses',
				value: 'lastThreeMonths',
				disabled: false,
			},
			{
				text: 'Mês Atual',
				value: 'currentMonth',
				disabled: false,
			},
			{
				text: 'Personalizado',
				value: 'custom',
				disabled: false,
			},
			{
				text: 'Nenhuma Seleção de Data',
				value: 'noDate',
				disabled: false,
			},
			{
				text: 'Personalizado',
				value: 'custom',
				disabled: false,
			},
		],
		selectedDate: 'lastThirtyDays',
		dateType: ['createdAt'],
		dateList: [
			{
				text: 'Últimos 7 dias',
				value: 'lastSevenDays',
				disabled: false,
			},
			{
				text: 'Últimos 30 dias',
				value: 'lastThirtyDays',
				disabled: false,
			},
			{
				text: 'Últimos 3 meses',
				value: 'lastThreeMonths',
				disabled: false,
			},
			{
				text: 'Mês Atual',
				value: 'currentMonth',
				disabled: false,
			},
			{
				text: 'Nenhuma Seleção de Data',
				value: 'noDate',
				disabled: false,
			},
			{
				text: 'Personalizado',
				value: 'custom',
				disabled: false,
			},
		],
		justFilesToReprocess: false,
		overlay: false,
		menu: false,
		date: null,
		changeTabValue: 'FILE_DATA',
		fieldFilterProps: {
			outlined: true,
			dense: true,
			hideDetails: true,
			clearable: false,
			color: "primary",
			itemColor: "primary",
			placeholder: "Filtrar data",
		},
		autoCompleteProps: {
			placeholder: "Selecione",
			hideDetails: true,
			itemText: "name",
			itemValue: "id",
			outlined: true,
			clearable: true,
			dense: true,
			color: "foreground--text",
			itemColor: "foreground--text",
		},
		autoCompleteCarrierProps: {
			placeholder: "Selecione",
			itemText: "carrierName",
			hideDetails: true,
			itemValue: "carrierId",
			outlined: true,
			clearable: true,
			dense: true,
			color: "foreground--text",
			itemColor: "foreground--text",
		},
		textFieldProps: {
			outlined: true,
			clearable: true,
			dense: true,
			hideDetails: true,
			color: "foreground--text",
			itemColor: "foreground--text",
		},
		contracts: [],
		subContracts: [],
		loadingContracts: false,
		loadingSubContracts: false,
		watcherCalledGetContract: false,
		watcherCalledGetSubContract: false,
		overlay: false,
		carriers: [],
		debounceTimer: null,
	}),

	props: {
		financialGroups: { type: Array },
		insuranceCarriers: { type: Array },
		resetFilterDataLoad: {
			type: Boolean,
			default: false
		},
		loadSearch: {
			type: Boolean,
			default: false
		},
		parameters: {
			type: Object,
			default: () => ({})
		},
		filtersForCheckDate: {
			type: Object,
			default: () => ({})
		},
	},

	mixins: [
		AuthorityManagementMixin,
		InsuranceCarriersMixin,
		ContractsMixin,
		DataLoadMixin,
	],

	watch: {
		date: {
			deep: true,
			handler(value) {
				if (value) this.setCompentence();
			},
		},
		filterDataLoad: {
			deep: true,
			immediate: true,
			handler(value, oldValue) {
				if (value) {
					this.$emit("hasFiltersDataLoad", this.filterDataLoad)

					if (oldValue && this.isOnlyFileNameChanged(value, oldValue)) {
						return;
					}

					this.debounceSearch();
				}
			}
		},
		resetFilterDataLoad: {
			deep: true,
			handler(value) {
				if (value) this.clearFilterDataLoad()
			}
		},
		'filterDataLoad.financialGroupId': {
			deep: true,
			handler(value) {
				this.filterDataLoad.contractId = null;
				this.filterDataLoad.subContractId = null;
				const financialGroupId = lodash.cloneDeep(value);
				if (financialGroupId) {
					if (!this.watcherCalledGetContract) {
						this.loadContractsByFinancialGroupId(financialGroupId);
					}
				} else {
					this.contracts = [];
					this.subContracts = [];
					this.watcherCalledGetContract = false;
				}
			},
		},
		'filterDataLoad.contractId': {
			deep: true,
			handler(value) {
				this.filterDataLoad.subContractId = null;
				if (value) {
					if (!this.watcherCalledGetSubContract) {
						this.loadSubContractsByContractId(value);
					}
				} else {
					this.subContracts = [];
					this.watcherCalledGetSubContract = false;
				}
			},
		},
		selectedDate: {
			immediate: true,
			deep: true,
			handler(newValue) {
				const dateValue = newValue || 'lastThirtyDays';
				this.setDateFilter(dateValue);
				this.checkSelectedDate();
				setTimeout(() => {
					this.handlerFilter();
				}, 200)
			},
		},
	},

	methods: {
		debounceSearch() {
			this.$emit('loading', true);

			clearTimeout(this.debounceTimer);

			this.debounceTimer = setTimeout(() => {
				this.handlerFilter();
			}, 2000);
		},
		loadParameters() {
			if (!this.parameters) return;
			if (this.parameters.helpdeskId) this.filterDataLoad.helpdeskId = Number(this.parameters.helpdeskId);
			if (this.parameters.carrierId) this.filterDataLoad.carrierId = Number(this.parameters.carrierId);
			if (this.parameters.financialGroupId) this.filterDataLoad.financialGroupId = Number(this.parameters.financialGroupId);
			if (this.parameters.contractId) this.filterDataLoad.contractId = Number(this.parameters.contractId);
			if (this.parameters.subject) this.filterDataLoad.subject = this.parameters.subject;
			if (this.parameters.competency) this.filterDataLoad.competence = moment(this.parameters.competency, 'YYYY-MM').format('MM/YYYY');
			this.debounceSearch();
			},
		async setMandatoryCarriers() {
			await this.dataLoadService.GetAllConfigMandatoryExtFile().then(res => {
				if (res.data.length > 0) {
					this.carriers = [];
					res.data.forEach((carrier, index) => {
						if (index === 0) {
							this.carriers.push(carrier);
						}
						if (
							carrier.carrierId != null
							&& !this.carriers.some(item => item.carrierId === carrier.carrierId)
						) {
							this.carriers.push(carrier);
						}
					});

					this.carriers.sort((a, b) => (a.carrierName > b.carrierName ? 1 : -1));
				}
			})
		},
		expand() {
			if (this.filterExpanded === 0) {
				this.filterExpanded = undefined
			} else {
				this.filterExpanded = 0
			}
		},
		handlerClearFilters() {
			sessionStorage.removeItem('searchParams');
			this.$emit('clearFilters');
		},
		setDateFilter(value) {
			const today = moment();
			const dateRanges = {
				lastSevenDays: 6,
				lastThirtyDays: 29,
				lastThreeMonths: 89,
				currentMonth: today.clone().startOf('day').diff(today.clone().startOf('month').startOf('day'), 'days'),
				noDate: 'noDate',
			};

			let startDate;
			if (value === 'noDate') {
				this.dates = [];
				startDate = [];
			} else if (dateRanges[value] !== undefined) {
				startDate = today.clone().subtract(dateRanges[value], 'days');
				this.dates = [startDate.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')];
			}

			sessionStorage.setItem('selectedDate', this.selectedDate);
			this.setDataCustom(this.dates);
		},
		checkSelectedDate() {
			if (this.selectedDate === 'noDate') {
				this.$emit('openExpandedContent', 0);
			}
		},
		handlerFilter() {
			if (this.filterDataLoad.fileName) {
				this.filterDataLoad.fileName = this.filterDataLoad.fileName.trim();
			}
			if (this.validateObject()) {
				if (this.dateType.length !== 0 || this.selectedDate === 'noDate') {
					let { dates } = this;
					if (this.selectedDate === 'noDate') {
						dates = [];
					} else {
						this.setDateFilter(this.selectedDate)
						dates = this.dates
					}
					const { dateType } = this;
					sessionStorage.removeItem('searchParams');
					this.$emit('handlerClickFilter', dates, dateType);
				} else {
					this.menu = true;
					this.$refs.SnackbarCustomize.open('error', 'Selecione um tipo de data para prosseguir');
				}
			}
		},
		validateObject() {
			if (this.selectedDate === 'noDate') {
				if (!this.filtersForCheckDate) return true;
				const {
					subject, createdBy, carrierId, financialGroupId, contractId,
					subContractId, id, status, extProcessStatus, competence, fileName
				} = this.filtersForCheckDate;

				const showMessageAndReturnFalse = (message) => {
					this.$refs.SnackbarCustomize.open('error', message);
					return false;
				};

				if (this.areAllMandatoryFieldsEmpty(
					subject, createdBy, carrierId, financialGroupId, contractId,
					subContractId, id, status, extProcessStatus, competence, fileName)
				) {
					return showMessageAndReturnFalse('Preencha pelo menos um campo para prosseguir com a pesquisa ou selecione uma data específica');
				}

				if (this.areSpecificConditionsMet(
					subject, createdBy, carrierId, financialGroupId, contractId,
					subContractId, id, status, extProcessStatus, competence, fileName)
				) {
					return showMessageAndReturnFalse('Adicione um outro filtro de pesquisa para prosseguir ou selecione uma data específica');
				}

				if (this.areAdditionalConditionsMet(
					subject, createdBy, carrierId, financialGroupId, contractId,
					subContractId, id, status, extProcessStatus, competence, fileName)
				) {
					return showMessageAndReturnFalse('Adicione um outro filtro de pesquisa para prosseguir ou selecione uma data específica');
				}

				return true;
			}

			return true;
		},
		areAllMandatoryFieldsEmpty(...fields) {
			return fields.every((field) => this.isEmpty(field));
		},
		areSpecificConditionsMet(
			subject, createdBy, carrierId, financialGroupId, contractId,
			subContractId, id, status, extProcessStatus, competence, fileName
		) {
			return (
				this.isEmpty(id)
				&& this.isEmpty(subject)
				&& this.isEmpty(createdBy)
				&& this.isEmpty(carrierId)
				&& this.isEmpty(financialGroupId)
				&& this.isEmpty(contractId)
				&& this.isEmpty(subContractId)
				&& this.isEmpty(id)
				&& this.isEmpty(competence)
				&& this.isEmpty(status)
				&& this.isEmpty(extProcessStatus)
				&& this.isEmpty(fileName)
			);
		},
		areAdditionalConditionsMet(
			subject, createdBy, carrierId, financialGroupId, contractId,
			subContractId, id, status, extProcessStatus, competence, fileName
		) {
			return (
				this.isEmpty(id)
				&& this.isEmpty(subject)
				&& this.isEmpty(createdBy)
				&& this.isEmpty(carrierId)
				&& this.isEmpty(financialGroupId)
				&& this.isEmpty(contractId)
				&& this.isEmpty(subContractId)
				&& this.isEmpty(id)
				&& this.isEmpty(competence)
				&& this.isEmpty(status)
				&& this.isEmpty(extProcessStatus)
				&& this.isEmpty(fileName)
			);
		},
		isOnlyFileNameChanged(newValue, oldValue) {
			const keys = new Set([...Object.keys(newValue), ...Object.keys(oldValue)]);
			for (const key of keys) {
				if (key === 'fileName') continue;
				if (newValue[key] !== oldValue[key]) return false;
			}
			return newValue.fileName !== oldValue.fileName;
		},
		isEmpty(value) {
			return value === '' || value === undefined || value === null;
		},
		clearFilterDataLoad() {
			this.filterDataLoad = {
				uploadType: '',
				userName: '',
				carrierId: '',
				financialGroupId: '',
				contractId: '',
				subContractId: '',
				status: '',
				extProcessStatus: '',
				competence: '',
				fileName: '',
			},
				this.$forceUpdate();
			this.selectedDate = 'lastThirtyDays';
			this.$emit("resetStatusFilters", false);
		},
		loadThisFilter(data) {
			this.setOverlay(true);
			this.filterDataLoad = {
				subject: data.queryParams.subject ? data.queryParams.subject : '',
				createdBy: data.queryParams.createdBy ? data.queryParams.createdBy : '',
				carrierId: data.queryParams.carrierId ? parseInt(data.queryParams.carrierId) : '',
				financialGroupId: data.queryParams.financialGroupId ? parseInt(data.queryParams.financialGroupId) : '',
				contractId: data.queryParams.contractId ? parseInt(data.queryParams.contractId) : '',
				subContractId: data.queryParams.subContractId ? parseInt(data.queryParams.subContractId) : '',
				id: data.queryParams.id ? data.queryParams.id : '',
				status: data.queryParams.status ? data.queryParams.status : '',
				extProcessStatus: data.queryParams.extProcessStatus ? data.queryParams.extProcessStatus : '',
				competence: data.queryParams.competence ? data.queryParams.competence : '',
			};

			this.$emit('hasFiltersDataLoad', this.filterDataLoad);

			setTimeout(() => {
				this.setOverlay(false);
			}, 500);
		},
		setOverlay(value) {
			this.overlay = value;
		},
		loadContractsByFinancialGroupId(financialGroupId) {
			return new Promise((resolve) => {
				this.getContractsByFinancialGroupId(financialGroupId).then(() => {
					resolve();
				});
			});
		},
		loadSubContractsByContractId(contractId) {
			return new Promise((resolve) => {
				this.getSubContractsByContractId(contractId).then(() => {
					resolve();
				});
			});
		},
		setCompentence() {
			if (Boolean(this.date)) {
				this.filterDataLoad.competence = moment(this.date, 'YYYY-MM').format('MM/YYYY');
			}
			this.menu = false;
		},

		cleanCompetence() {
			this.filterDataLoad.competence = null;
			this.date = null;
		},
		handlerDate(dates) {
			this.datesSearch = null;
			this.menuDateCustom = false;
			const dateFormated = dates;

			if (dateFormated[0] > dateFormated[1]) {
				[dateFormated[0], dateFormated[1]] = [dateFormated[1], dateFormated[0]];
			}

			this.$refs.menuDateCustom.save(dateFormated);
			this.setDataCustom(dateFormated);
			this.handlerFilter();
		},
		setDataCustom(dates) {
			if (this.selectedDate === 'custom') {
				const cleanedDates = dates.map((date) => {
					if (date.includes('T00:00:00.000')) {
						date = date.replaceAll('T00:00:00.000', '');
					}
					if (date.includes('T23:59:59.999')) {
						date = date.replaceAll('T23:59:59.999', '');
					}
					return date;
				});
				const datesSearch = {
					dateType: this.dateType,
					dates: cleanedDates,
				};
				this.datesSearch = datesSearch;
			}
		},
	},

	computed: {
		dateRangeText() {
			let text = '-';
			if (this.dates && this.dates.length > 0) {
				const sortedDates = this.dates.slice().sort((a, b) => new Date(a) - new Date(b));

				const formattedStartDate = moment(sortedDates[0]).format('DD/MM/YYYY');
				const formattedEndDate = moment(sortedDates[1]).format('DD/MM/YYYY');

				text = `${formattedStartDate} ~ ${formattedEndDate}`;
			}

			return text;
		},
		syncIconTransition() {
			return {
				transform: this.filterExpanded !== 0 ? 'rotate(180deg)' : 'rotate(0deg)',
				transition: 'transform 0.25s',
			};
		},
		uploadFilePermission() {
			return this.hasPermission('sdi_carga_fatura_acao_upload');
		},
	},

	created() {
		this.dataLoadService = new DataLoadService();
	},

	async mounted() {
		await this.setMandatoryCarriers();
		this.loadParameters();
	},
}
</script>

<style scoped>
.onClickEffect {
	/* color: transparent !important; */
	background-color: transparent !important;
}

.onClickEffect:after {
	/* color: transparent !important; */
	background-color: transparent !important;
}

@keyframes rotate {
	from {
		transform: rotate(360deg);
	}

	to {
		transform: rotate(0deg);
	}
}

.syncSearchTransition {
	transform: 0.5s ease-out;
	animation: rotate 1.2s linear infinite;
}

.filter-header-label {
	margin-top: 16px;
}

.filter-expand-icon {
	margin-top: 4px;
}
</style>
